module.exports = __webpack_public_path__ + "img/logo_kambly_small.40d540e9.webp";